import { Component, OnInit, } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthserviceService } from 'src/app/services/authservice.service';
import { Router } from '@angular/router';
import { UndefinedNullableString } from 'src/app/type-alias';
import { SideBarComponent } from '../side-bar/side-bar.component';
import { AppSessionStorageService } from 'src/app/services/utils/session-storage.service';

@Component({
  selector: 'app-profile-view',
  standalone: true,
  imports: [SideBarComponent],
  templateUrl: './profile-view.component.html',
  styleUrl: './profile-view.component.css',
})
export class ProfileViewComponent implements OnInit {
  constructor(
    private authService: AuthserviceService,
    private router: Router
  ) {}
  private imageSubscription: Subscription | undefined;
  ngOnInit(): void {
    AppSessionStorageService.sideBarSelection = 2
    this.userDetails();
  }

  async userDetails() {
    if(!AppSessionStorageService.user){
      await this.authService.fetchUserDetails();
    }
  }

  get fullName():string{
    return (AppSessionStorageService.user?.firstname ?? '') + ' ' + (AppSessionStorageService.user?.lastname ?? '');
    }
    
  get userName():string{
    return AppSessionStorageService.user?.username ?? '';
  }

  get profileImage():string {
    return this.authService.getUserImage() ?? 'assets/default-image.svg';
      
    }
    

  logout() {
    this.authService.logout();
  }

  ngOnDestroy(): void {
    this.imageSubscription?.unsubscribe();
  }

  editProfileView(){
    if(AppSessionStorageService?.auth?.role == 'installer'){
      this.router.navigate(['/installer/edit/profile'])
    }else if(AppSessionStorageService?.auth?.role == 'administrator'){
      this.router.navigate(['/admin/edit/profile'])
    }
  }

  changePassword(){
    if(AppSessionStorageService?.auth?.role == 'installer'){
      this.router.navigate(['/installer/change/password'])
    }else if(AppSessionStorageService?.auth?.role == 'administrator'){
      this.router.navigate(['/admin/change/password'])
    }
  }
}
